import { createAction, props } from '@ngrx/store';
import { MapModels } from '@models/map.models';

export const resetToInitialState = createAction('[MAP OBJECTS] Reset to Initial state');


export const getAllObjects = createAction('[MAP OBJECTS] Get all objects');
export const sendGetAllObjectsRequest = createAction('[MAP OBJECTS] Get all objects request');
export const getAllObjectsSuccess = createAction(
  '[MAP OBJECTS] Get all objects success',
  props<{ objects: MapModels.MapObject[] }>(),
);
export const getAllObjectsFail = createAction('[MAP CUSTOM OBJECTS] Get all objects fail');

export const setIsLoading = createAction(
  '[MAP OBJECTS] Set isLoading',
  props<{ isLoading: boolean }>(),
);

export const getMarkerPicture = createAction('[MAP OBJECTS] Get marker picture', props<{ id: string }>());
export const sendMarkerPictureRequest = createAction('[MAP OBJECTS] Get marker picture request', props<{ id: string }>());
export const getMarkerPictureSuccess = createAction(
  '[MAP OBJECTS] Get marker picture success',
  props<{ imageUrl: string }>(),
);

export const getMarkerPictureFail = createAction(
  '[MAP OBJECTS] Get marker picture fail');

export const resetImageUrl = createAction('[MAP OBJECTS] Reset image url');

